import type { StyleSpecification } from "@maplibre/maplibre-gl-style-spec";
import { getGlobalStateForLocalization } from "@americana/diplomat";
import * as Layers from "../layer/index.js";

// Generate style.json
export function build(
  tileURL: string,
  spriteURL: string,
  glyphURL: string,
  locales: string[]
): StyleSpecification {
  return {
    name: "Americana",
    glyphs: glyphURL,
    layers: Layers.build(locales),
    sources: {
      ohm: {
        tiles: [
          "https://vtiles.openhistoricalmap.org/maps/ohm/{z}/{x}/{y}.pbf",
        ],
        type: "vector",
      },
      ohm_other_boundaries: {
        tiles: [
          "https://vtiles.openhistoricalmap.org/maps/ohm_other_boundaries/{z}/{x}/{y}.pbf",
        ],
        type: "vector",
      },
      osm_land: {
        tiles: [
          "https://vtiles.openhistoricalmap.org/maps/osm_land/{z}/{x}/{y}.pbf",
        ],
        type: "vector",
      },
      ne: {
        tiles: ["https://vtiles.openhistoricalmap.org/maps/ne/{z}/{x}/{y}.pbf"],
        type: "vector",
      },
      dem: {
        attribution:
          '<a target="_blank" rel="noopener" href="https://registry.opendata.aws/terrain-tiles/">Terrain Tiles</a>',
        type: "raster-dem",
        tiles: [
          "https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png",
        ],
        encoding: "terrarium",
        tileSize: 256,
        // The actual maxzoom is 15
        maxzoom: 13,
      },
    },
    sprite: spriteURL,
    light: {
      anchor: "viewport",
      color: "white",
      intensity: 0.12,
    },
    version: 8,
  };
}
